export enum UiHeaderType {
  DEFAULT = 'default',
  EYE_BROW = 'eyeBrow',
  MENU = 'menu',
}
